import React from "react"
import parse from "html-react-parser"
import InView from "react-intersection-observer"
import { motion } from "framer-motion"
import * as helpers from "../../helpers/sectionclasses"
import ButtonGroup from "../buttongroup"
// import Image from "gatsby-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
// import CloudinaryVideo from "./../cloudinaryvideo"
import loadable from "@loadable/component";

const CloudinaryVideo = loadable(() => import("../cloudinaryvideo"), {
  ssr: false, // Disables Server-Side Rendering
});


const Columns = ({ content }) => {
  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  return (
    <section className={`columns ${sectionClasses}`}>
      <div className="container">
        {content.label || content.title ? (
          <InView threshold={0.5} triggerOnce={true}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, y: 35 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 35 }}
                transition={{ duration: 0.8 }}
                className={`${
                  content.centerIntro ? "tab:flex tab:justify-center" : ""
                } ${
                  content.pullUpFirstSection
                    ? "relative z-10 tab:pb-0 tab:-mb-40"
                    : "tab:pb-20"
                }`}
              >
                <div
                  className={`${
                    content.centerIntro
                      ? "lrg:px-6 tab:w-9/12"
                      : "lrg:px-6 tab:w-full"
                  }`}
                >
                  {content.label ? (
                    <p className="label mb-2">{parse(content.label)}</p>
                  ) : (
                    ""
                  )}
                  {content.title ? (
                    <p className="text-md lrg:text-xl">
                      {parse(content.title)}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </motion.div>
            )}
          </InView>
        ) : (
          ""
        )}

        {content.rows &&
          content.rows.map((row, index) => {
            let rowClasses = `row flex flex-wrap
            ${row.bottomSpacing ? row.bottomSpacing : ""}
            ${row.topSpacing ? row.topSpacing : ""}
            ${row.columnLayout ? row.columnLayout : ""}
            ${row.verticalColumnLayout ? row.verticalColumnLayout : ""}
            ${row.reverseColumnOrder ? "flex-row-reverse" : ""}
            ${row.fullWidth ? "full-width-row" : ""}
          `

            return (
              <div className={rowClasses} key={index}>
                {row.columns &&
                  row.columns.map((column, index) => {
                    let colClasses = `col pt-6 pb-6

                    ${column.reduceMobileWidth ? "px-12" : ""}
                    
                    ${
                      row.fullWidth && row.columns.length <= 2 ? "" : "lrg:px-6"
                    }
                    ${column.width ? "tab:" + column.width + "" : ""}
                    ${
                      column.pushDown
                        ? "transform lrg:translate-y-2/4 z-10"
                        : ""
                    }
                  `
                    return (
                      <div className={colClasses} key={index}>
                        {column.colType === "text" ? (
                          <InView threshold={0.5} triggerOnce={true}>
                            {({ ref, inView }) => (
                              <motion.div
                                ref={ref}
                                initial={{ opacity: 0, y: 35 }}
                                animate={
                                  inView
                                    ? { opacity: 1, y: 0 }
                                    : { opacity: 0, y: 35 }
                                }
                                transition={{ duration: 0.8 }}
                              >
                                <div className="article-body">
                                  {parse(column.text)}
                                </div>
                              </motion.div>
                            )}
                          </InView>
                        ) : (
                          <>
                            {column.colType === "image" ? (
                              <>
                                {column.image?.localFile?.childImageSharp && (
                                  <InView threshold={0.5} triggerOnce={true}>
                                    {({ ref, inView }) => (
                                      <motion.div
                                        ref={ref}
                                        initial={{ opacity: 0, y: 35 }}
                                        animate={
                                          inView
                                            ? { opacity: 1, y: 0 }
                                            : { opacity: 0, y: 35 }
                                        }
                                        transition={{ duration: 0.8 }}
                                      >
                                        <GatsbyImage 
                                            image={getImage(column.image.localFile.childImageSharp)} 
                                            className="w-full" 
                                            alt={column.image.altText} 
                                            loading="eager"
                                            layout="fullWidth"
                                        />
                                      </motion.div>
                                    )}
                                  </InView>
                                )}
                              </>
                            ) : (
                              <>
                                {column.anim && (
                                  <CloudinaryVideo publicUrl={column.anim} />
                                )}
                              </>
                            )}
                          </>
                        )}
                        {column.buttons ? (
                          <ButtonGroup
                            classes="pt-14"
                            buttonarray={column.buttons}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    )
                  })}
              </div>
            )
          })}
      </div>
    </section>
  )
}

export default Columns
